import { ServiceDefinition } from '@pershing/pershing-core';

export class RGLServiceDefinition implements ServiceDefinition {
    private static instance: ServiceDefinition = null;
    version = 'v1';
    family = 'netxinvestor';
    appName = 'gains-losses-svc';
    serviceName = 'app';
    mnemonic = 'nxc';
    uri = 'gains-losses';
    static getInstance(): ServiceDefinition {
        if (!RGLServiceDefinition.instance) {
            RGLServiceDefinition.instance = new RGLServiceDefinition();
        }
        return RGLServiceDefinition.instance;
    }
    
    static getRglSummaryURL(baseURL: string, context: string, contextValue: string, queryParams: any, termParams: any, searchWordParam: any) {
        return `${baseURL}/${context}/${contextValue}?${queryParams}&groupView=true&pageSize=2000${termParams}${searchWordParam}`;
    }
}

export class UGLServiceDefinition implements ServiceDefinition {
    private static instance: ServiceDefinition = null;
    version = 'v1';
    family = 'netxinvestor';
    appName = 'gains-losses-svc';
    serviceName = 'app';
    mnemonic = 'nxc';
    uri = 'gains-losses/ugl';
    static getInstance(): ServiceDefinition {
        if (!UGLServiceDefinition.instance) {
            UGLServiceDefinition.instance = new UGLServiceDefinition();
        }
        return UGLServiceDefinition.instance;
    }
    static getAccountContext( context: string ): string {
        switch (context) {
            case 'account': {
                return 'accounts';
            }
            case 'client': {
                return 'clients';
            }
            case 'household': {
                return 'households';
            }
            case 'group': {
                return 'groups';
            }
            case 'ibdoffip': {
                return 'ibdoffips';
            }
            default: {
                return context;
            }
        }
    }

    static getUglSummaryURL(baseURL: string, context: string, contextValue: string) {
        return `${baseURL}/${UGLServiceDefinition.getAccountContext(context)}/${contextValue}?quoteType=D&isCashIncluded=true&pageSize=2000`;
    }
}
